/**
 * Shared environment detection utilities
 */

export const isLocalhost = () =>
  ['localhost', '127.0.0.1'].includes(window.location.hostname);

export const isCypress = () =>
  typeof window !== 'undefined' && Boolean(window.Cypress);

export const isDatadogSynthetic = () => {
  // Primary: User agent (official Datadog identification)
  if (
    navigator.userAgent.includes('DatadogSynthetics') ||
    navigator.userAgent.includes('Datadog/Synthetics') ||
    navigator.userAgent.includes('Datadog Synthetics')
  ) {
    console.debug('Synthetic detected: DatadogSynthetics in user agent');
    return true;
  }

  // Secondary: WebDriver flag (catches Selenium/Puppeteer)
  if (navigator.webdriver === true) {
    console.debug('Synthetic detected: WebDriver flag');
    return true;
  }

  return false;
};

export const shouldSkipDatadog = () => isLocalhost() || isDatadogSynthetic();

export const isSafari = () => {
  const ua = navigator.userAgent;
  // Safari's UA contains "Safari" but not the tokens other WebKit-based
  // browsers add (Chrome, Chromium, Edge, Firefox-on-iOS, Chrome-on-iOS, etc.)
  return (
    /safari/i.test(ua) &&
    !/chrome|chromium|crios|fxios|edg|android|opr|opera/i.test(ua)
  );
};

export const isMobileBrowser = () =>
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  ) ||
  // iPadOS 13+ reports a desktop UA but exposes touch on a "Mac"
  (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

export const isUnsupportedBrowser = () => isSafari() || isMobileBrowser();
